import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@crowdfpl/ui-web/dialog';
import { NotificationPreferencesForm } from './NotificationPreferencesForm';

interface NotificationPreferencesModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export function NotificationPreferencesModal({ isOpen, onClose }: NotificationPreferencesModalProps) {
  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="w-[calc(100vw-2rem)] sm:w-full sm:max-w-[425px] rounded-2xl">
        <DialogHeader>
          <DialogTitle>Notification preferences</DialogTitle>
        </DialogHeader>
        <NotificationPreferencesForm />
      </DialogContent>
    </Dialog>
  );
}
